import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';

import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';

const useOtherTopicsName = () => {
  const { currentUser } = useDefaultAppContexts();
  const { totalAllCategories } = useTopicsIndexContext();
  const menuName = usePageMenuName(PAGES.TOPICS, __('groups'));

  let name = __('Discover');

  if (totalAllCategories > 0) {
    name = __('Others');
  }

  if (currentUser) {
    if (totalAllCategories > 0) {
      name = s__('Topics|Other %{menuName}').i__({
        menuName,
      });
    } else {
      name = s__('Topics|Discover %{menuName}').i__({
        menuName,
      });
    }
  }

  return name;
};

export default useOtherTopicsName;
